// extracted by mini-css-extract-plugin
module.exports = {"capitalizeInput":"ManageWordsForm_capitalizeInput__16Yqn"};